export class ContractType {
    public static readonly None: string = 'None';
    public static readonly Fix: string = 'Fix';
    public static readonly Freelance: string = 'Freelance';
    public static readonly Fse: string = 'Fse';
    public static readonly Tzv: string = 'Tzv';
}

export interface IContractTypeValueLabel {
    value: ContractType;
    label: string;
}

export class ContractTypeModel {
    public static readonly None: string = 'None';
    public static readonly TZV_Month: string = 'TZV_Month';
    public static readonly TZV_Day: string = 'TZV_Day';
    public static readonly TZV_VariableBlock: string = 'TZV_VariableBlock';
    public static readonly TZV_VariableDay: string = 'TZV_VariableDay';
    public static readonly TZV_FixBlock: string = 'TZV_FixBlock';
    public static readonly TZV_FixDay: string = 'TZV_FixDay';
    public static readonly TZV_Ground: string = 'TZV_Ground';
    public static readonly TZV_Spez: string = 'TZV_Spez';
    public static readonly FL_A: string = 'FL_A';
    public static readonly FL_C: string = 'FL_C';
    public static readonly FL_B: string = 'FL_B';
    public static readonly FL_S: string = 'FL_S';
    public static readonly TZV_FixDay_Sh: string = 'TZV_FixDay_Sh';
    public static readonly TZV_FixDay_Mff: string = 'TZV_FixDay_Mff';
    public static readonly TZV_VariableDay_LhSff: string = 'TZV_VariableDay_LhSff';
    public static readonly TZV_R: string = 'TZV_R';
}

export interface IContractTypeModelValueLabel {
    value: ContractTypeModel;
    label: string;
}

export class ContractPartTimeSplitTypes {
    public static readonly Split: string = 'Split';
    public static readonly Block: string = 'Block';
}